import { Injectable } from '@angular/core';
import { BodyScrollLockService } from '../../services/dom/body-scroll-lock.service';

@Injectable({
  providedIn: 'root'
})
export class SliderService {
  private sliders: { [key: string]: { open: boolean; data?: any; canClose?: boolean; isEdition?: boolean } } = {};

  constructor(private bodyScrollLock: BodyScrollLockService) { }

  public openSlider(type: string, data?: any, isEdition: boolean = false) {
    const wasOpen = this.isSliderOpen(type);
    this.sliders[type] = { open: true, data, canClose: true, isEdition };
    if (!wasOpen) {
      this.bodyScrollLock.lock();
    }
  }

  public closeSlider(type: string) {
    if (this.sliders[type] && this.sliders[type].canClose !== false) {
      const wasOpen = this.sliders[type].open;
      this.sliders[type].open = false;
      this.sliders[type].data = undefined;
      if (wasOpen) {
        this.bodyScrollLock.unlock();
      }
    }
  }

  public isSliderOpen(type: string): boolean {
    return !!this.sliders[type]?.open;
  }

  public getData<T = any>(type: string): T | undefined {
    return this.sliders[type]?.data as T;
  }
}
